import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Article } from '@/models/article/Article';
import { Workspace } from '@/models/Workspace';
import mobileResponsiveService from '@/services/MobileResponsiveService';
import store from '@/store';
import {
  RETENTION_STATUS_HINTS,
  RETENTION_STATUS_LABELS,
  RetentionStatus,
  resolveArticleRetentionStatus,
} from '@/other/retentionStatus';

/**
 * Indicates inside an opened article that its recordings are protected from the retention
 * policy — either by the workspace default (SNAP-2246) or by the article's own flag (SNAP-2265).
 * Renders nothing when the company has no retention policy or the article has no recordings.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'RetentionStatusBadge',
  props: {
    article: null,
    workspace: null
  },
  setup(__props: any) {

const props = __props as {
  article: Article | null;
  workspace?: Workspace | null;
}



const isRetentionEnabled = computed(() => store.state.company?.retention?.enabled ?? false);

const hasRecordings = computed(() => !!props.article?.paragraphs?.length);

const status = computed<RetentionStatus | null>(() => {
  if (!isRetentionEnabled.value || !hasRecordings.value) return null;
  return resolveArticleRetentionStatus({ article: props.article, workspace: props.workspace });
});

const label = computed(() => (status.value ? RETENTION_STATUS_LABELS[status.value] : ''));
const hint = computed(() => (status.value ? RETENTION_STATUS_HINTS[status.value] : ''));
const icon = computed(() => (status.value === RetentionStatus.LONG_TERM_RETAINED ? 'lock' : 'verified_user'));

const isMobile = computed(() => mobileResponsiveService.isMobileView);

return { __sfc: true,props, isRetentionEnabled, hasRecordings, status, label, hint, icon, isMobile }
}

})